import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconModule } from '@y42/core/icon';
import { ContainerWithSideDetailViewComponent } from './container-with-side-detail-view.component';
import { SideDetailViewDirective } from './side-detail-view.directive';
import { TitleModule } from './title/title.module';

@NgModule({
  imports: [
    CommonModule,
    MatSidenavModule,
    MatButtonModule,
    FontAwesomeModule,
    MatProgressBarModule,
    MatIconModule,
    TitleModule,
    IconModule,
  ],
  declarations: [ContainerWithSideDetailViewComponent, SideDetailViewDirective],
  exports: [ContainerWithSideDetailViewComponent, SideDetailViewDirective],
})
export class ContainerWithSideDetailViewModule {}
